import { Button, FloatingBanner, Typography } from '@up2rent/ui-new';
import { isNil } from 'lodash';
import { useIntl } from 'react-intl';

import { useActiveOrganization } from 'src/auth/client';
import { useUser } from 'src/hooks/UserContext';

const ImpersonationBanner = () => {
  const { formatMessage } = useIntl();
  const { impersonatedBy, stopImpersonating, userAttributes } = useUser();
  const { data: activeOrganization } = useActiveOrganization();

  if (isNil(impersonatedBy)) {
    return null;
  }

  return (
    <FloatingBanner tone="warn">
      <Typography className="whitespace-nowrap font-semibold text-fg-inverse">
        {formatMessage(
          { id: 'impersonation.banner' },
          { name: userAttributes?.name ?? '', client: activeOrganization?.name ?? '' }
        )}
      </Typography>
      <Button
        id="stopImpersonatingButton"
        size="sm"
        onClick={stopImpersonating}
        className="shrink-0 bg-fg-inverse text-warn hover:bg-fg-inverse/90"
      >
        {formatMessage({ id: 'impersonation.stop' })}
      </Button>
    </FloatingBanner>
  );
};

export default ImpersonationBanner;
